import React from 'react'
import Footer from '../Footer/Footer'
import Header from '../Header'
import Us from '../Us/Us'
import Mission from "../Mission/Mission"
import Solution from '../Solutions/Solutions'
import Aims from '../Aims/Aims'
import Partners from '../Partners/Partners'
import Director from '../Director/Director'
import Vice from '../Vice/Vice'

const About = () => {
  return (
    <div>
        <Header />
        <Mission />
        <Aims />
        <br />
        <br />
        <Vice />
        <br />
        <br />
        <Director />
        <br />
        <br />
        <Footer />
    </div>
  )
}

export default About